import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneRadiology } from "../../../../../../../../store/actions";
import { useParams, useHistory } from "react-router-dom";
import View from "../../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewOneRadiology = ({ getOneRadiology, OneRadiology, patient }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [Radiology, setRadiology] = useState(null);
  const { medicalId } = useParams();
  const toast = useToast();
  let history = useHistory();

  useEffect(() => {
    if (medicalId && patient) {
      getOneRadiology(medicalId, toast, history, patient.id);
    }
  }, []);

  useEffect(() => {
    const { loading, error, data } = OneRadiology;
    setLoading(loading);
    setError(error);
    if (data) {
      setRadiology(data);
    }
  }, [OneRadiology]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View MRI / CT Scan"
        one={Radiology}
        history={history}
        viwer={true}
      />
    );
  };
  return renderView();
};

const mapStateToProps = (state) => {
  return {
    OneRadiology: state.OneRadiology,
  };
};
export default connect(mapStateToProps, { getOneRadiology })(ViewOneRadiology);
